














































import { Component, Vue } from 'vue-property-decorator';
import { Button } from 'ant-design-vue';

interface OptionsObject {
  gradeId: number;
  period: number;
  subjectId: number;
  // createdClass: number;
  typesId: number;
}

@Component({
  components: {
    AButton: Button,
  },
})
export default class ClassSelect extends Vue {
  private hasFilterOptions: boolean = false;

  private showMore: boolean = false;

  private optionIndex: number = 2; // 控制展示列表：conditionList 项数量，默认展示前两项（需要配合列表加入数据的顺序）

  private conditionList: any[] = [];

  private options: OptionsObject = {
    gradeId: 0, // 年级
    period: 1, // 学期
    subjectId: 0, // 学科（待定）
    // createdClass: 0, // 建班
    typesId: 0, // 类型
  };

  // 条件查询
  private handleSelect(conditionType: string, conditionId: number) {
    const typeMap = {
      subject: 'subjectId',
      grade: 'gradeId',
      period: 'period',
      // class: 'createdClass',
      type: 'typesId',
    };

    // if (conditionType === 'class') {
    //   this.options.typesId = 0;
    // }

    const typeId = typeMap[conditionType];
    if (this.options[typeId] !== conditionId) {
      if (conditionType === 'subject') {
        const subjectsList: any[] = this.conditionList[0].list;
        const gradeList: any[] = subjectsList.filter((item: any) => item.id === conditionId);
        const selectGradeList = gradeList[0].list;
        this.conditionList.forEach((item) => {
          if (item.type === 'grade') {
            item.list = selectGradeList;
          }
        });
        this.options.gradeId = 0; // 年级默认置为全部
      }
      this.options[typeId] = conditionId;
      // 我的班级筛选条件本地存储
      this.$utils.setStore('myClassFilter', this.options);
      this.$bus.$emit('parmasChange', this.options);
    }
  }

  // 获取选项接口数据
  private getConditionList() {
    this.$service.bk.getMyCondition().then((result: any) => {
      const { gradeData, periodData, typesData } = result;
      if (!gradeData.list.length
        && !periodData.list.length
        && !typesData.list.length) {
        this.hasFilterOptions = false;
      } else {
        this.hasFilterOptions = true;
        const base = {
          id: 0,
          name: '全部',
        };
        this.conditionList = [];

        // 年级、学期、类型加入全部选项
        if (result.subjectData.list.length > 1) {
          // 多学科的年级展示对应科目的年级
          result.subjectData.list.forEach((item: any) => {
            item.list.unshift(base);
          });
          result.gradeData.list = result.subjectData.list[0].list;
        } else {
          result.gradeData.list.unshift(base);
        }

        result.periodData.list.unshift(base);
        result.typesData.list.unshift(base);
        this.conditionList.push(result.gradeData);
        this.conditionList.push(result.periodData);
        this.conditionList.push(result.typesData);
        /**
         * 判断是否有学科数据
         * 如果有，
         *  1. 给options的学科id设置选中第一项的值
         *  2. 如果学科数据超过1个，
         *     a.  展示学科选项
         *     b. 学期展示“全部”
         *  3. 如果学科数据只有一个
         *     a. 不展示学科选项
         *     b. 学期展示current项
         */
        let period = result.periodData.current;
        if (result.subjectData.list.length > 1) {
          this.options.subjectId = result.subjectData.list[0].id;
          // 将学科数据插入到数组第一的位置， 用于前两项展示的设计
          this.conditionList.splice(0, 0, result.subjectData);
          period = 0;
        }
        this.options = { ...this.options, period };
      }
      // 默认获取筛选项根据本地存储数据为准
      const option = this.$utils.getStore('myClassFilter');
      if (option && Object.keys(option).length > 0) {
        if (result.typesData && result.typesData.list.length > 0) {
          const isHas = result.typesData.list.some((item: any) => item.id === option.typesId);
          if (!isHas) {
            option.typesId = result.typesData.list[0].id;
          }
        }
        this.options = option;
      }
      this.$bus.$emit('parmasChange', this.options);
    });
    // .then(() => {
    //   // 默认获取筛选项根据本地存储数据为准
    //   const option = this.$utils.getStore('myClassFilter');
    //   if (option && Object.keys(option).length > 0) {
    //     this.options = option;
    //   }
    //   this.$bus.$emit('parmasChange', this.options);
    // });
  }

  // 处理显示更多功能
  private handleShowMore() {
    this.$utils.sendAction('index', 'history', 'id-13');
    this.showMore = !this.showMore;
    this.optionIndex = this.showMore ? this.conditionList.length : 2;
  }

  mounted() {
    this.getConditionList();
  }
}
